import { PasswordInput } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../translations';
import { PasswordUpdateFormController } from '../PasswordUpdateForm.types';

type OldPasswordFieldProps = Pick<PasswordUpdateFormController, 'register'>;

export const OldPasswordField = (props: OldPasswordFieldProps): JSX.Element => {
   const controller = props.register(OldPasswordField.fieldName, { required: true });

   return (
      <PasswordInput
         testId={'oldPassword'}
         autoComplete={'off'}
         label={personnelTranslationKeys.myAccount.password.oldPassword}
         controller={controller}
      />
   );
};

OldPasswordField.fieldName = 'oldPassword' as const;
